import { render, staticRenderFns } from "./detailsWindow.vue?vue&type=template&id=1e7e9338&scoped=true"
import script from "./detailsWindow.vue?vue&type=script&lang=js"
export * from "./detailsWindow.vue?vue&type=script&lang=js"
import style0 from "./detailsWindow.vue?vue&type=style&index=0&id=1e7e9338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7e9338",
  null
  
)

export default component.exports